var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82859 4.4593C6.74142 4.24838 6.53543 4.11104 6.3072 4.11166C6.07897 4.11229 5.87374 4.25076 5.78773 4.46216L4.61672 7.34L4.04229 8.69069C3.9207 8.97657 4.05389 9.30688 4.33978 9.42846C4.62566 9.55004 4.95597 9.41685 5.07755 9.13097L5.50811 8.11858H7.13259L7.58005 9.13708C7.705 9.4215 8.03687 9.55078 8.32129 9.42582C8.60571 9.30087 8.73499 8.969 8.61003 8.68458L8.01735 7.33551L6.82859 4.4593ZM6.65872 6.99358H5.97224L6.31281 6.15663L6.65872 6.99358Z",
    fill: "#748399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52954 3.50592C1.52954 2.6904 2.19065 2.0293 3.00617 2.0293H9.67263C10.4881 2.0293 11.1493 2.6904 11.1493 3.50592V10.1724C11.1493 10.9879 10.4881 11.649 9.67263 11.649H3.00617C2.19065 11.649 1.52954 10.9879 1.52954 10.1724V3.50592ZM3.00617 3.07784C2.76974 3.07784 2.57809 3.2695 2.57809 3.50592V10.1724C2.57809 10.4088 2.76974 10.6005 3.00617 10.6005H9.67263C9.90905 10.6005 10.1007 10.4088 10.1007 10.1724V3.50592C10.1007 3.2695 9.90905 3.07784 9.67263 3.07784H3.00617Z",
    fill: "#748399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1255 6.81224C13.4361 6.81224 13.688 7.06408 13.688 7.37474V11.4378C13.688 12.9566 12.4567 14.1878 10.938 14.1878H6.82554C6.51488 14.1878 6.26304 13.936 6.26304 13.6253C6.26304 13.3147 6.51488 13.0628 6.82554 13.0628H10.938C11.8354 13.0628 12.563 12.3353 12.563 11.4378V7.37474C12.563 7.06408 12.8148 6.81224 13.1255 6.81224Z",
    fill: "#748399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.5b76b8e4cab350753120f63676f4fdbf.svg";
export { ForwardRef as ReactComponent };